import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

import { changeDescription } from '../../utils/functions';
import GoogleButton from '../../components/GoogleButton/GoogleButton';
import styles from './GetMealPlan.module.css';

const GetMealPlan = () => {
  useEffect(() => {
    const description = 'Answer a few quick questions and let our AI build a custom meal plan just for you. Tailored to your goals, diet, and lifestyle. Start now — it’s free!';
    changeDescription(description);
  }, []);

  return (
    <div className={styles.wrapper}>
      <Helmet>
        <title>
          Create Your Personalised Meal Plan | MealWell Quiz
        </title>
      </Helmet>
      <Link 
        className={'back-button'} 
        to="/" 
      />
      <div className={styles.content}>
        <div className="medium-text">
          Let’s create a meal plan for you
        </div>
        <div className="small-text">
          Meal Well makes eating well easy and enjoyable every day.
        </div>
        <Link className={cn('green-button', styles.createButton)} to="/register">
          Create account
        </Link>
        <GoogleButton />
        <div className={cn('medium-text', styles.already)}>
          Already have account?
        </div>
        <Link className={cn('green-button', styles.login)} to="/login">
          Log in
        </Link>
      </div>
    </div>
  );
};

export default GetMealPlan;
